// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1362":"38547b26c651458d","2524":"2891efee7eef1719","3937":"08fefc3242242eac","4647":"9f95353cafd27d97","7113":"473d22c442f39852"}[chunkId] + ".css";
};